module.exports = __webpack_public_path__ + "static/media/Marathon.e3ab23f9.jpg";